import { Button, TextInput } from "flowbite-react";
import React from "react";
import { CreatePackagePayload } from "../../types/payload/create-package-payload";
import { ImageCarouselInput } from "../carousel/ImageCarouselInput";
import { TextInputLabel } from "../label/TextInputLabel";
import { Footnote12Description } from "../typography/Footnote12Description";
import { ButtonColor } from "@/common/enum/button-color";
import { MemoInput } from "../memo/MemoInput";
import { CustomEditor } from "../tiptap/CustomEditor";
import { getTextLength } from "@/common/util/jsonUtils";

interface Props {
  payload: CreatePackagePayload;
  handleFileChange: (files: File[]) => void;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleCatalogChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleMemoChange: (index: number, value: string) => void;
  handleAddMemo: () => void;
  handleRemoveMemo: (index: number) => void;
}

export const PackageCreatePanel: React.FC<Props> = ({
  payload,
  handleFileChange,
  handleChange,
  handleMemoChange,
  handleAddMemo,
  handleRemoveMemo,
}) => {
  return (
    <div className="flex bg-primary-white rounded-[8px] p-[24px]">
      <ImageCarouselInput
        files={payload.files}
        onFileChange={handleFileChange}
      />
      <div className="flex flex-col ml-[20px] gap-[16px]">
        <div className="flex gap-[16px]">
          <div className="flex flex-col">
            <TextInputLabel required>상품명</TextInputLabel>
            <TextInput
              required
              className="w-[398px]"
              name="name"
              placeholder="상품명을 입력해주세요"
              value={payload.name}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col">
            <TextInputLabel required>모델명</TextInputLabel>
            <TextInput
              required
              className="w-[398px]"
              name="modelName"
              placeholder="모델명을 입력해주세요"
              value={payload.modelName}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex py-[8px]">
          <div className="flex flex-col gap-[8px]">
            <div className="text-semantic-text-heading mb-[4px]">
              <TextInputLabel>상품 메모</TextInputLabel>
            </div>
            {payload.memos.length === 0 ? (
              <Button
                onClick={handleAddMemo}
                color={ButtonColor.CUSTOM_GRAY}
                className="w-[32px]"
              >
                +
              </Button>
            ) : (
              payload.memos.map((memo, index) => (
                <MemoInput
                  key={index}
                  value={memo}
                  index={index}
                  onChange={handleMemoChange}
                  onRemove={handleRemoveMemo}
                  onAdd={handleAddMemo}
                  isMaxMemos={payload.memos.length >= 10}
                />
              ))
            )}
          </div>
        </div>
        <div className="flex gap-[16px]">
          <div className="flex flex-col">
            <TextInputLabel required>상품 설명</TextInputLabel>
            <CustomEditor
              content={payload.details}
              handleContentChange={(newContent) =>
                handleChange({
                  target: { name: "details", value: newContent },
                } as React.ChangeEvent<HTMLInputElement>)
              }
              style={{ width: "398px" }}
            />
            <Footnote12Description className="text-semantic-text-secondary mt-[12px]">{`(${getTextLength(
              payload.details
            )} / 1,000)`}</Footnote12Description>
          </div>
          <div className="flex flex-col">
            <TextInputLabel required>기능 설명</TextInputLabel>
            <CustomEditor
              content={payload.features}
              handleContentChange={(newContent) =>
                handleChange({
                  target: { name: "features", value: newContent },
                } as React.ChangeEvent<HTMLInputElement>)
              }
              style={{ width: "398px" }}
            />
            <Footnote12Description className="text-semantic-text-secondary mt-[12px]">{`(${getTextLength(
              payload.features
            )} / 1,000)`}</Footnote12Description>
          </div>
        </div>
      </div>
    </div>
  );
};
